import { call, put } from 'redux-saga/effects';
import axios from './axiosHandler';
import { API_HOST } from '../env';
import sagaLoading from './sagaLoading';
import { MESSAGE_ERROR, GET_SINGLE_AUDIO_DETAILS_SUCCESS } from '../actions/actionTypes';

export default function* sagaGetAudioDetails({ id }) {
  try {
    yield call(sagaLoading, true);
    const resData = yield call(() =>
      axios({
        url: `${API_HOST}content/getSingle`,
        method: 'post',
        data: { id },
      }).then((response) => response.data)
    );
    yield put({ type: GET_SINGLE_AUDIO_DETAILS_SUCCESS, payload: resData.data });
    yield call(sagaLoading, false);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield call(sagaLoading, false);
    yield put({
      type: MESSAGE_ERROR,
      payload: error.message ? error.message : 'There is something wrong, please, try again.',
    });
  }
}
